module.exports = __webpack_public_path__ + "img/seb.4f13a403.jpeg";